var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "TheHeader" },
    [
      _c(
        "div",
        { staticClass: "topbar" },
        [
          _c("LanguageSwitcher"),
          _c(
            "div",
            { staticClass: "logo" },
            [
              _c("router-link", { attrs: { to: "/" } }, [
                _c("img", {
                  attrs: {
                    src: require("@/assets/images/logo.svg"),
                    alt: "",
                    width: "200"
                  }
                })
              ])
            ],
            1
          ),
          _c("div", { staticClass: "user" }, [
            _vm.logged
              ? _c("div", { staticClass: "user" }, [
                  _c("img", {
                    attrs: {
                      src: _vm.loadImageServer(_vm.userImage()),
                      alt: ""
                    }
                  }),
                  _c(
                    "button",
                    { staticClass: "register", on: { click: _vm.userId } },
                    [_vm._v(" " + _vm._s(_vm.$t("HEADER.DISCIPLINES")) + " ")]
                  ),
                  _c(
                    "button",
                    { staticClass: "login", on: { click: _vm.logout } },
                    [_vm._v(" " + _vm._s(_vm.$t("HEADER.LOGOUT")) + " ")]
                  )
                ])
              : _c("div", [
                  _c(
                    "button",
                    {
                      staticClass: "register",
                      on: {
                        click: function($event) {
                          return _vm.$router.push({ name: "Form" })
                        }
                      }
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("HEADER.SIGNUP")) + " ")]
                  ),
                  _c(
                    "button",
                    { staticClass: "login", on: { click: _vm.showModal } },
                    [_vm._v(" " + _vm._s(_vm.$t("HEADER.LOGIN")) + " ")]
                  )
                ])
          ])
        ],
        1
      ),
      _c("div", { staticClass: "header" }, [
        _c("h1", [_vm._v(_vm._s(_vm.$t("HEADER.TITLE")))]),
        _c("p", {
          staticClass: "description",
          domProps: { innerHTML: _vm._s(_vm.$t("HEADER.DESCRIPTION")) },
          on: { click: _vm.showModal2 }
        })
      ]),
      _c(
        "transition",
        { attrs: { name: "fade" } },
        [
          _vm.isOpen
            ? _c("Login", {
                on: {
                  close: function($event) {
                    _vm.isOpen = false
                  }
                }
              })
            : _vm._e()
        ],
        1
      ),
      _c(
        "transition",
        { attrs: { name: "fade" } },
        [
          _vm.isOpen2
            ? _c("Requirements", {
                on: {
                  close: function($event) {
                    _vm.isOpen2 = false
                  }
                }
              })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }